// src/features/tasks/components/TasksEmptyState.jsx
import React from 'react';
import {
  Box,
  Typography,
  Button,
} from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Add as AddIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const FILTER_OPTIONS = [
  { value: 'all', labelKey: 'tasks:filtering.all' },
  { value: 'my-tasks', labelKey: 'tasks:filtering.my_tasks' },
  { value: 'today', labelKey: 'tasks:filtering.today' },
  { value: 'overdue', labelKey: 'tasks:filtering.overdue_tasks' },
  { value: 'pending', labelKey: 'tasks:filtering.pending' },
  { value: 'in-progress', labelKey: 'tasks:filtering.in_progress' },
  { value: 'completed', labelKey: 'tasks:filtering.completed' },
];

export default function TasksEmptyState({
  currentFilter,
  canCreate,
  onCreateClick,
}) {
  const { t } = useTranslation(['tasks']);

  const currentFilterOption = FILTER_OPTIONS.find(opt => opt.value === currentFilter);
  const filterLabel = currentFilterOption ? t(currentFilterOption.labelKey) : currentFilter;

  const isAllTasksFilter = currentFilter === 'all';
  const isMyTasksFilter = currentFilter === 'my-tasks';
  const title = t('tasks:list_page.no_tasks_found');
  const message = isAllTasksFilter
    ? t('tasks:list_page.no_tasks_created')
    : isMyTasksFilter
    ? t('tasks:list_page.completed_all_tasks')
    : t('tasks:list_page.no_tasks_match_filter', { filter: filterLabel });

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      minHeight={400}
    >
      <AssignmentIcon sx={{ fontSize: 64, color: 'text.disabled', mb: 2 }} />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center" paragraph>
        {message}
      </Typography>
      {canCreate && isAllTasksFilter && (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onCreateClick}
        >
          {t('tasks:list_page.create_first_task')}
        </Button>
      )}
    </Box>
  );
}